import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class TaskService {
  static loadTasks() {
    const url = `${endpoints.BASE_URL}${endpoints.TASKS}`;
    return axios.get(url).then((response) => response.data);
  }

  static getTask(id) {
    const url = `${endpoints.BASE_URL}${endpoints.TASKS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createTask(task) {
    const url = `${endpoints.BASE_URL}${endpoints.TASKS}`;
    const body = {
      task
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateTask(task) {
    const url = `${endpoints.BASE_URL}${endpoints.TASKS}/${task.id}`;
    const body = {
      task
    };

    return axios.put(url, body).then((response) => response.data);
  }
}

export default TaskService;
